import React, { useState, useEffect, useCallback } from "react";
import apiCampaign from "./api";
import CampaignStatTiles from "./dashboard/CampaignStatTiles";
import CampaignList from "./campaign-list/CampaignList";

const Campaigns = () => {
  const [stats, setStats] = useState(null);
  const [statsLoading, setStatsLoading] = useState(true);

  const loadStats = useCallback(async () => {
    try {
      const res = await apiCampaign.dashboardStats();
      setStats(res.data?.data || null);
    } finally {
      setStatsLoading(false);
    }
  }, []);

  useEffect(() => { loadStats(); }, [loadStats]);

  return (
    <div className="bg-surface_alt h-full flex flex-col overflow-hidden">
      <div className="max-w-[100rem] mx-auto w-full h-full flex flex-col overflow-hidden">
        <div className="h-full overflow-y-auto">
          <div className="space-y-4 pt-6 pb-4">
            <CampaignStatTiles stats={stats} loading={statsLoading} />
            <CampaignList onStatsChange={loadStats} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Campaigns;
